import { EESimStatus } from "@pages/AccountDetails/interface/IAccountDetailsPage";

export const DISPLAYABLE_ESIM_STATUS_LIST: EESimStatus[] = [
    EESimStatus.ENABLED,
    EESimStatus.DOWNLOADED,
    EESimStatus.INSTALLED,
    EESimStatus.DELETED,
];
